export default class Main {
    constructor() {
        this.init();
    }

    init() {}
}
